export const SET_STATE_SIDEBAR_USER = "SETSTATESIDEBAR_USER";

export function setStateSidebarUser(payload) {
  return {
    type: SET_STATE_SIDEBAR_USER,
    payload,
  };
}
